import React from "react";

export const animalesAlmirantePublishedAt = (
  <span className="white">
    Revista <i>Vida</i>, No. 53, 1952
  </span>
);
